import ApiClient from "@/api/ApiClient.ts";

const state = {
  services: null,
  servicesBookings: null,
  servicesBookingsData: {},
  servicesBookingsWithFilters: [],
  servicesBookingsDataRecycler: {},
  servicesPeriodicData: {},
  servicesPeriodicWithFilters: [],
  servicesPeriodicDataRecycler: {},
};

const mutations = {
  setServices(state, services) {
    state.services = services;
  },

  setServicesBookings(state, services) {
    state.servicesBookings = services;
  },

  setServicesBookingsData(state, data) {
    state.servicesBookingsData = data;
  },

  setServicesBookingsWithFilters(state, services) {
    state.servicesBookingsWithFilters = services;
  },

  setServicesBookingsDataRecycler(state, data) {
    state.servicesBookingsDataRecycler = data;
  },

  setServicesPeriodicData(state, data) {
    state.servicesPeriodicData = data;
  },

  setServicesPeriodicWithFilters(state, services) {
    state.servicesPeriodicWithFilters = services;
  },

  setServicesPeriodicDataRecycler(state, data) {
    state.servicesPeriodicDataRecycler = data;
  },
};

const actions = {
  async getServicesBookings({ commit }, customParams) {
    const params = {
      mode: "listScheduledServices",
      ...customParams,
    };
    try {
      const api = ApiClient();
      let response = await api.get("services/services2", { params });
      commit("setServicesBookings", response.data);
      return response.data;
    } catch (error) {
      console.error("ERROR en getServicesBookings: ", error.message);
    }
  },

  async getServiceById(_, params) {
    try {
      const api = ApiClient();
      let response = await api.get("/services", { params });
      return response.data;
    } catch (error) {
      console.error("ERROR en getServiceById: ", error.message);
      throw error;
    }
  },

  async createService(_, { data, params }) {
    try {
      return await ApiClient().post("services/services2", data, {
        params: params,
      });
    } catch (error) {
      console.error("ERROR en createService: ", error.message);
      throw error;
    }
  },

  async deleteService(_, params) {
    try {
      const api = ApiClient();
      await api.delete("services", {
        params,
      });
      return true;
    } catch (error) {
      console.error("ERROR en deleteService: ", error.message);
    }
  },

  async updateService(_, payload) {
    const { params, data } = payload;

    try {
      const api = ApiClient();
      return await api.patch("/services", data, { params });
    } catch (error) {
      console.error("ERROR en updateService: ", error.message);
      throw error;
    }
  },

  async getServicesPeriodic(_, params) {
    try {
      const api = ApiClient();
      let response = await api.get("/services/periodic2", { params });
      return response.data;
    } catch (error) {
      console.error("ERROR en getServicesPeriodic: ", error.message);
      throw error;
    }
  },

  async updateServicePeriodic(_, payload) {
    const { params, data } = payload;

    try {
      const api = ApiClient();
      await api.patch("/services/periodic", data, { params });
    } catch (error) {
      console.error("ERROR en updateServicePeriodic: ", error.message);
      return error.message;
    }
  },

  async deleteServicePeriodic(_, params) {
    try {
      const api = ApiClient();
      let response = await api.delete("services/periodic", {
        params,
      });
      return response.data;
    } catch (error) {
      console.error("ERROR en deleteServicePeriodic: ", error.message);
    }
  },
};

const getters = {
  services(state) {
    return state.services;
  },

  servicesBookings(state) {
    return state.servicesBookings;
  },

  servicesBookingsData(state) {
    return state.servicesBookingsData;
  },

  servicesBookingsWithFilters(state) {
    return state.servicesBookingsWithFilters;
  },

  servicesBookingsDataRecycler(state) {
    return state.servicesBookingsDataRecycler;
  },

  servicesBookingsBySlice: (getters) => (start, end) => {
    if (getters.servicesBookings.length) {
      return getters.servicesBookings.slice(start, end);
    }
  },

  servicesPeriodicData(state) {
    return state.servicesPeriodicData;
  },

  servicesPeriodicWithFilters(state) {
    return state.servicesPeriodicWithFilters;
  },

  servicesPeriodicDataRecycler(state) {
    return state.servicesPeriodicDataRecycler;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
